<template>
  <div>
    <b-row align-v="center" class="d-flex align-items-center">
      <b-col cols="4" class="mb-4">
        <label class="text-capitalize">{{ $tc("victronenergy.master_account.title", 1) }}</label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="victronenergyMasterAccountFilter"
          :options="victronenergyMasterAccountOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:victronenergyMasterAccountFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <!-- Units -->
      <b-col cols="4" class="mb-4">
        <label style="text-transform: capitalize">
          {{ $tc("unit.title", 2) }}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="unitFilter"
          :options="unitOptions"
          class="w-100"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:unitFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>

      <b-col cols="4" class="mb-4">
        <label style="text-transform: capitalize">
          {{ $t('dmp.tags')}}
        </label>
        <v-select
          :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
          :value="tagFilter"
          :options="tagOptions"
          class="w-100"
          label="name"
          multiple
          :reduce="(val) => val.value"
          @input="(val) => $emit('update:tagFilter', val)"
          append-to-body
          :calculate-position="withPopper"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BRow,
  BCol,
  BButton,
} from "bootstrap-vue";
import vSelect from "vue-select";
import popperHelper from '@/libs/popper-helper';

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BButton,
    vSelect,
  },
  props: {
    tenantOptions: {
      type: Array,
      default: null,
    },
    tenantFilter: {
      type: Array,
      default: null,
    },
    victronenergyMasterAccountOptions: {
      type: Array,
      default: null,
    },
    victronenergyMasterAccountFilter: {
      type: Array,
      default: null,
    },
    unitOptions: {
      type: Array,
      default: null,
    },
    unitFilter: {
      type: [Array],
      default: null,
    },
    tagOptions: {
      type: Array,
      default: null,
    },
    tagFilter: {
      type: [Array],
      default: null,
    },
  },
  setup() {
    return {
      withPopper: popperHelper.withPopper,
    };
  },
};
</script>
